import React from 'react';

/**
 * Section 1 : Informations préalables
 */
const AssessmentSection1_Prealables = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange('prealables', {
      ...data,
      [field]: value
    });
  };

  return (
    <div className="assessment-section-content">
      <h3 className="assessment-section-title">INFORMATIONS PRÉALABLES</h3>
      <p className="assessment-section-description">
        Ce questionnaire a pour objectif d'évaluer votre situation globale et vos besoins spécifiques
        afin de vous proposer un accompagnement personnalisé et adapté.
      </p>

      <div className="assessment-info-card">
        <p><strong>Durée de l'évaluation :</strong> 1h à 1h30</p>
        <p><strong>Principe :</strong> Toutes les informations recueillies sont strictement confidentielles
        et protégées par le secret professionnel. Elles sont utilisées uniquement pour construire votre
        projet d'accompagnement personnalisé.</p>
        <p><strong>Participation :</strong> Vous êtes libre de ne pas répondre à certaines questions.
        Vous pouvez être accompagné(e) de la personne de votre choix (famille, personne de confiance).</p>
      </div>

      <div className="assessment-grid-2">
        <div className="assessment-form-group">
          <label>Date de l'évaluation</label>
          <input
            type="date"
            className="assessment-form-control"
            value={data?.evaluationDate || ''}
            onChange={(e) => handleChange('evaluationDate', e.target.value)}
          />
        </div>

        <div className="assessment-form-group">
          <label>Durée estimée de l'évaluation</label>
          <input
            type="text"
            className="assessment-form-control"
            placeholder="Ex: 1h30"
            value={data?.evaluationDuration || ''}
            onChange={(e) => handleChange('evaluationDuration', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default AssessmentSection1_Prealables;
